import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJ_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MSG_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const storageRef = storage.ref();
const currentUser = auth.currentUser;

const usersCollection = db.collection('users');
const kalameetingCollection = db.collection('kalameeting');
const roomsCollection = db.collection('rooms');
const meetingsCollection = db.collection('meetings');
const meetingImages = storageRef.child('meetingImages');

export default {
    db,
    auth,
    currentUser,
    usersCollection,
    kalameetingCollection,
    roomsCollection,
    meetingsCollection,

    storage,
    storageRef,
    meetingImages
};
